/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {
  defaultErrorValues,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Assurance/AssuranceVoyage/resiliation';
import {IError} from '../../data/types/interface/Assurance/AssuranceVoyage/resiliation';

export const useFormResiliation = (
  data: any,
  Validate: any,
  onCancel: any,
  handleSave: any,
  listAgence?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultErrorValues);

  const isDisable = () => !noError(Validate(values));

  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    setValues({...values, [name]: value});
  };

  const noError = (errors: IError) => {
    let bNoError = true;
    Object.values(errors).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setErrors(Validate(values, listAgence));
    if (noError(errors)) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  const handleCancel = () => {
    setValues(data);
    onCancel();
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {
    handleChange,
    handleSubmit,
    isDisable,
    handleCancel,
    values,
    errors,
    showErrors,
    dto,
  };
};
